import { render, staticRenderFns } from "./ui-form-data.vue?vue&type=template&id=1e1faa1c&scoped=true"
import script from "./ui-form-data.vue?vue&type=script&lang=js"
export * from "./ui-form-data.vue?vue&type=script&lang=js"
import style0 from "./ui-form-data.vue?vue&type=style&index=0&id=1e1faa1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1faa1c",
  null
  
)

export default component.exports